import React from 'react';
import {Card, Flex} from "antd";
import {CategoryCardProps} from "../../models";
import {
    ToolOutlined
} from '@ant-design/icons';
import style from"./Category.module.scss"
import {StyledCard} from "./Category.styled";
const CategoryCard = ({icon , title, onCategoryClick,id}:CategoryCardProps) => {
    return (
        <StyledCard onClick={() => onCategoryClick(id)}>
            <Flex gap={"middle"} align={"center"} vertical justify={"center"}>
                <img width={25} src={require(`assets/categoryIcons/${icon}`)}/>
                <p className={style.CardTitle}>{title}</p>
            </Flex>
        </StyledCard>
    );
};

export default CategoryCard;
